import { Component, OnInit } from '@angular/core';
import { Router  , ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { IBreadcrumbItem, BreadcrumbSupport } from './interfaces';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  breadcrumbs$: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.breadcrumbs$ = this.router.events
      .pipe(
        // tap(event => console.log(event)),
        filter(event => event instanceof NavigationEnd),
        // distinctUntilChanged(),
        map(event =>  {
          this.buildBreadCrumb(this.activatedRoute.root);
          console.log('h1');

        }));

    // this.router.events
    //   .pipe(
    //     filter(event => event instanceof NavigationEnd))
    //   .subscribe(() => {
    //     this.breadcrumbItems = this.createBreadcrumbs(this.route.root);
    //     console.log( this.breadcrumbItems);
    //   });
  }

  private buildBreadCrumb(route: ActivatedRoute, url: string = '#', breadcrumbs: IBreadcrumbItem[] = []): IBreadcrumbItem[] {

    if (route.component && route.component instanceof BreadcrumbSupport) {
        const v = route.component.createBreadcrumbs();
    }
    return [];

  }
}
